import React from "react";
import image from './assets/service.jpg';

function Services()
{
    return(
        <>
        <div className="pagecontainer"> 
           <div className="flexrow">
                <div className="itembox">
                <h1>Its a Service Page</h1>
        <p>Get in touch with us here.</p>
                </div>

                 <div className="itembox">
                 <img src={image} alt="services" />
                </div>
           </div>

        </div>
        </>
    );
};
export default Services;